import { render, staticRenderFns } from "./TripOrderReady.vue?vue&type=template&id=45e83f84&scoped=true&"
import script from "./TripOrderReady.vue?vue&type=script&lang=js&"
export * from "./TripOrderReady.vue?vue&type=script&lang=js&"
import style0 from "./TripOrderReady.vue?vue&type=style&index=0&id=45e83f84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e83f84",
  null
  
)

export default component.exports